export enum PaymentStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  REVERSED = 'REVERSED',
  REVERSED_FAIL = 'REVERSED_FAIL',
  CANCELLED = 'CANCELLED',
}



// WEBPACK FOOTER //
// ./src/app/pages/orders/enums/payment-status.enum.ts